import React from 'react';
import PersonPage from './PersonPage';

export default function IllustratorPage() {
  return <PersonPage endpoint="illustrators" label="Illustrator" />;
}
